import { render, staticRenderFns } from "./support-chatbot.html?vue&type=template&id=eeb1c4fa&scoped=true&external"
import script from "./support-chatbot.js?vue&type=script&lang=js&external"
export * from "./support-chatbot.js?vue&type=script&lang=js&external"
import style0 from "./support-chatbot.scss?vue&type=style&index=0&id=eeb1c4fa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb1c4fa",
  null
  
)

export default component.exports